import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { columns } from "./table-config";

export function MeasurementsOverview() {
	/** Hooks */

	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["measurements-overview"],
		queryFn: async () => {
			const response = await client.measurements.users.overview.$get();
			const data = await responseHandler(response);
			return data.aggregatedMeasurements;
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={guardArray(data)}
				columns={columns}
				persistenceKey="measurements-overview-table"
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				initialPinningState={{
					start: ["firstName", "lastName"],
					end: ["progress", "actions"],
				}}
				menu={null}
			/>
		</ContentBox>
	);
}
